<template lang="html">
  <section class="vh intro">
    <img class="w-100" src="/static/img/bkg/bkg-area-tecnica.webp" :alt="$t('area_tecnica.alt_images.juntas_culata_mls')">
    <a href="#" v-scroll-to="'.desc-area'" class="scrolldown"></a>
    <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft">
      <div class="container-text">
        <h1 class="title title-52">{{ $t('area_tecnica.intro.titulo') }}</h1>
        <p v-html="$t('area_tecnica.intro.texto')"></p>
        <div class="flex column">
          <span class="title" v-for="(opt, key) in $t(`area_tecnica.nav_options`)" :key="key">
            <router-link :to="getRedirect($t(`enlaces.${opt.category}`), opt)">
              {{ opt.title }}
            </router-link>
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
export default {
  name: 'area-tecnica',
  props: [],
  data() {
    return {}
  },
  methods: {
    getRedirect: function (option, anchor) {
      let redirect = anchor.hasOwnProperty("category") ? `${option}/${anchor.id}` : anchor.id;
      return redirect;
    },
  },
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/view-parts/intros/area-tecnica.vue